<template>
    <div class="card">
        <div class="position-absolute end-0 mt-3 me-2 d-flex align-items-center">
            <div class="custom-control form-check form-switch me-3 mt-2">
                <input class="form-check-input" type="checkbox" id="checkbox" v-model="includePublic"
                    @change="updateJobTemplatesList()" />
                <label class="form-check-label" for="checkbox">Include Public Templates</label>
            </div>
        </div>
        <Datatable tableId="jobTemplatesTable" uniqueField="id" :columns="columns" :data="jobTemplates" :compact="true"
            :orderColumn="orderColumn" :formatColumn="formatColumn" :showLoading="loading" :detailColumn="{
                baseUrl: 'job-templates/',
                identifier: 'id',
                name: 'Cid Specific Job Template',
            }" />
    </div>
</template>

<script>
import Datatable from "../../components/Datatable.vue";
import { mapActions } from "vuex";

export default {
    name: "JobTemplates",
    components: { Datatable },
    data() {
        return {
            columns: [
                { data: "name" },
                { data: "type" },
                { data: "created_by", title: "Created by" },
                { data: "created_at", title: "Created at" },
            ],
            orderColumn: [4, "desc"],
            //Note: index - table column index which need to formatted
            formatColumn: [
                {
                    index: 4,
                    type: "datetime",
                },
            ],
            loading: false,
            publicAndCidTemplates: null,
            includePublic: false,
        };
    },
    computed: {
        jobTemplates() {
            return this.$store.state.amdp.cidJobTemplates;
        },
    },
    async beforeMount() {
        try {
            this.loading = true;
            this.publicAndCidTemplates = await this.fetchCidJobTemplates({ public: true })
            this.updateJobTemplatesList()
        } catch (error) {
            let err = null
            if (error.response)
                err = error.response.data.error;
            else err = error.message;
            let toastoptions = {
                message: err || "Something went wrong while fetching job templates. Please contact support.",
                type: "error"
            }
            this.$store.dispatch("addToast", toastoptions);
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapActions('amdp', {
            fetchCidJobTemplates: 'fetchCidJobTemplates',
            setCidJobTemplates: 'setCidJobTemplates',
        }),
        updateJobTemplatesList() {
            if (this.includePublic) {
                this.setCidJobTemplates(this.publicAndCidTemplates)
            } else {
                const cidJobTemplates = this.jobTemplates.filter(jt => jt.cid === this.$store.state.currentClient.cid);
                this.setCidJobTemplates(cidJobTemplates)
            }
        }
    }
};
</script>

<style scoped></style>